import { Component, OnInit, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DiseaseProfile } from '../../models';
import { DiseaseProfilesState } from '../../store/reducers/disease-profiles.reducer';

import * as fromStore from '../../store';
import { PageData } from '../../../content/models';
import { map } from 'rxjs/operators';
import { Go, SetTags, SetTitle } from '../../../store';
import { SearchFieldComponent } from '../../../core/components/search-field/search-field.component';
import { CardComponent } from '../../../core/components/card/card.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { AsyncPipe } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { StringUtility, UrlRewritePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-disease-profile-overview',
  templateUrl: './disease-profile-overview.component.html',
  styleUrls: ['./disease-profile-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchFieldComponent, CardComponent, PaginationComponent, AsyncPipe, FromDictionaryPipe, UrlRewritePipe],
})
export class DiseaseProfileOverviewComponent implements OnInit {
  private store = inject<Store<DiseaseProfilesState>>(Store);

  #dict = new FromDictionaryPipe();

  profiles$ = this.store.selectSignal(fromStore.getAllOrderedDiseaseProfiles);
  searchString: string = '';

  page$ = this.store.selectSignal(fromStore.getDiseaseProfilesPage);
  pages$ = computed(() => {
    return Array((this.page$()?.pageCount || 0) + 1)
      .fill(0)
      .map((x, i) => i);
  });

  ngOnInit(): void {
    const title = `${this.#dict.transform('meta-disease-overview-title', false) || this.#dict.transform('ziektebeelden-overzicht-titel')} | ${this.#dict.transform('meta-title-suffix')}`;

    const description = StringUtility.Truncate(
      StringUtility.StripHTML(this.#dict.transform('meta-disease-overview-description', false) || this.#dict.transform('ziektebeelden-overzicht-intro-tekst')),
      157,
      '...'
    );
    this.store.dispatch(SetTitle({ title }));
    this.store.dispatch(SetTags({ properties: { 'description': description, 'og:title': title, 'og:description': description } }));
  }

  handleSearchInput(e: string) {
    this.store.dispatch(Go({ path: [], queryParams: { q: e, page: 0 } }));
  }
}
